import { useEffect, useState } from 'react';

export interface ScrollChrome {
  /** true once the page has scrolled off the very top */
  stuck: boolean;
  /** id of the section currently in view, for the nav highlight */
  activeId: string;
}

/** Drives the header's scrolled state and the scrollspy. */
export function useScrollChrome(sectionIds: string[]): ScrollChrome {
  const [state, setState] = useState<ScrollChrome>({
    stuck: false,
    activeId: '',
  });

  useEffect(() => {
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;

        let activeId = '';
        sectionIds.forEach((id) => {
          const el = document.getElementById(id);
          if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.34) {
            activeId = id;
          }
        });

        setState({
          stuck: y > 12,
          activeId,
        });
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [sectionIds]);

  return state;
}
